import app from "./firebase";

const db = app.firestore();
if(process.env.NODE_ENV === "development") {
    //TODO: do this programatically
    // db.useEmulator("localhost", 8080);
}

export default db;